import React, { useEffect, useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

// Lado maior que isto não desenha na miniatura (o JPEG vira quadrado branco).
// A ficha do cliente não usa este limite e continua com a foto inteira.
export const LIST_PROFILE_MAX_EDGE = 4096;

const sourceIsUnusable = (img, maxIntrinsicEdge) => {
  const w = img?.naturalWidth || 0;
  const h = img?.naturalHeight || 0;
  if (!w || !h) return true;
  if (maxIntrinsicEdge > 0 && (w > maxIntrinsicEdge || h > maxIntrinsicEdge)) {
    return true;
  }
  return false;
};

const ProfileImageWithFallback = ({
  src,
  alt = "Profile",
  fallbackType = "icon",
  width = "40px",
  height = "40px",
  borderRadius = "10px",
  objectFit = "cover",
  iconColor = "action.disabled",
  maxIntrinsicEdge = 0,
  style = {},
  ...props
}) => {
  const [hasError, setHasError] = useState(false);
  const showFallback = !src || hasError;

  // Reescreve URLs antigas fiddux-5a1f1 → fidduxai-rowy
  const displaySrc = src && typeof src === "string"
    ? src.replace(/fiddux-5a1f1\.appspot\.com/g, "fidduxai-rowy.appspot.com")
    : src;

  // A lista fica aberta enquanto a foto muda. Sem isso, um erro antigo
  // esconde a foto nova para sempre.
  useEffect(() => {
    setHasError(false);
  }, [displaySrc]);

  const baseStyle = {
    width,
    height,
    borderRadius,
    objectFit,
    ...style,
  };

  const handleLoad = (event) => {
    // Sem o limite, a ficha segue como antes: só o onError troca pelo ícone.
    if (!(maxIntrinsicEdge > 0)) return;
    const img = event.currentTarget;
    if (sourceIsUnusable(img, maxIntrinsicEdge)) {
      setHasError(true);
      return;
    }
    if (typeof img.decode === "function") {
      img.decode().catch(() => setHasError(true));
    }
  };

  if (showFallback) {
    return (
      <AccountCircleIcon
        sx={{
          fontSize: height,
          color: iconColor,
          minWidth: style.minWidth || width,
          minHeight: style.minHeight || height,
          flexShrink: style.flexShrink ?? 0,
        }}
        {...props}
      />
    );
  }

  return (
    <img
      src={displaySrc}
      alt={alt}
      style={baseStyle}
      {...props}
      onError={() => setHasError(true)}
      onLoad={handleLoad}
    />
  );
};

export default ProfileImageWithFallback;
